import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '@vex/utils/track-by';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { Router, RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { NgClass, NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../../../../core/auth/auth.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    NgIf,
    AsyncPipe
  ]
})
export class ToolbarUserDropdownComponent implements OnInit, OnDestroy {
  currentUser$ = this.authService.currentUser$;
  private destroy$ = new Subject<void>();
  
  items: MenuItem[] = [
    {
      id: '1',
      icon: 'mat:account_circle',
      label: 'Mi Perfil',
      description: 'Información personal',
      colorClass: 'text-teal-600',
      route: '/options-user/profile'
    }
  ];

  trackById = trackById;

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    // ⚠️ IMPORTANTE: Suscripción manual para forzar detección de cambios en OnPush
    // Esto resuelve el problema de que OAuth callbacks no actualizan la UI
    this.authService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        console.log('🔄 Dropdown detectó cambio en currentUser:', user);
        // Forzar detección de cambios en componente OnPush
        this.cd.markForCheck();
        console.log('✅ markForCheck() llamado en dropdown');
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Obtiene el nombre completo del usuario para mostrar
   * Prioridad: Nombres + Apellidos > Username > Email
   */
  getUserDisplayName(user: any): string {
    if (user.nombre && user.apellido) {
      return `${user.nombre} ${user.apellido}`.trim();
    } else if (user.nombre) {
      return user.nombre;
    } else if (user.email) {
      return user.email;
    }
    return 'Usuario';
  }

  getInitials(user: any): string {
    const n = user.nombre?.trim() ?? '';
    const a = user.apellido?.trim() ?? '';
    const initials = `${n.charAt(0)}${a.charAt(0)}`.toUpperCase();
    return initials || (user.email?.charAt(0).toUpperCase() ?? '?');
  }

  getAvatarColor(user: any): string {
    const seed = `${user.nombre ?? ''}${user.apellido ?? ''}`;
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `hsl(${Math.abs(hash) % 360}, 55%, 78%)`;
  }

  close() {
    this.popoverRef.close();
  }

  logout() {
    console.log('🚪 Ejecutando logout desde toolbar');
    this.authService.logout();
    this.close();
  }
}
